module.exports = __webpack_public_path__ + "static/img/sh_wtg.a2f893c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sh_wtg.png
// module id = Tbjq
// module chunks = 167